"use client"

import { ErrorMessage } from "@/app/error"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"
import {
  CollectionActivityTableReatom,
  CollectionActivityTableSkeletonReatom,
} from "./activity-table.reatom"

export function CollectionActivityViewReatom() {
  return (
    <ErrorBoundary
      fallback={
        <div className="flex h-full flex-col items-center justify-center">
          <ErrorMessage />
        </div>
      }
    >
      <Suspense fallback={<CollectionActivityTableSkeletonReatom />}>
        <CollectionActivityTableReatom />
      </Suspense>
    </ErrorBoundary>
  )
}
